import { useContext } from 'react';
import { AppContext } from '../../../Context/AppContext';
import { fbLogEvent } from '../../../Helpers/FirebaseHelper';
import { EVENT, SCREEN } from '../../../Constants/AnalyticsConstants';
import './DeviceInfo.scss';

interface IDeviceInfo {
  handleDeviceClick: () => void;
}

const DeviceInfo = (props: IDeviceInfo) => {
  const { isMobile } = useContext(AppContext);

  return (
    <div
      className="Device_Info"
      onClick={() => {
        fbLogEvent(EVENT.UE_DEVICE_INFO, {
          screen: isMobile ? SCREEN.MORE_MENU : SCREEN.PROFILE,
          lead: isMobile ? SCREEN.MORE_MENU : SCREEN.PROFILE,
        });
        props.handleDeviceClick();
      }}
    >
      <img
        src={`${isMobile ? '/oo/assets/icon/help.svg' : '/oo/assets/icon/info.svg'}`}
        alt="Device Info"
      />
      <p>Device Info</p>
    </div>
  );
};

export default DeviceInfo;
